import { module } from 'modujs';
import { TheRing } from '../utils/TheRing';
import gsap from 'gsap'
import bezier from 'bezier-easing'

const EASE = bezier(0.4,0,1.0,1.0);

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.ring = new TheRing(this.el);
        this.ring.load('/assets/3d/');

        this.renderBind = this.render.bind(this)
        gsap.ticker.add(this.renderBind);

        this.checkResizeBind = this.checkResize.bind(this)
        window.addEventListener('resize', this.checkResizeBind)

        this.onResize();
        requestAnimationFrame(() => {
            this.onResize();
        })
    }

    ///////////////
    // Rendering
    ///////////////
    render(time, deltaTime, frame) {
        this.ring?.tick?.(time * 10000);
    }

    ///////////////
    // Callback
    ///////////////
    checkResize() {
        if(!this.resizeTick) {
            this.resizeTick = true
            requestAnimationFrame(() => {
                this.onResize()
                this.resizeTick = false
            })
        }
    }

    onResize() {
        const { width, height, top, left } = this.el.getBoundingClientRect();
        this.BCR = { width, height, top, left };
        this.ring.resize(this.BCR.width, this.BCR.height);
    }

    onScrollProgress(progress) {
        this.ring.scrollProgress = EASE(progress);
        let autoRotate = gsap.utils.mapRange(.5, 1, 2, 20, EASE(progress))
        autoRotate = Math.max(2, Math.min(20, autoRotate));

        this.ring.autoRotate = autoRotate
    }

    //////////////
    // Methods
    /////////////
    launch() {
        this.ring.launch()
    }

    /////////////
    // Destroy
    /////////////
    destroy() {
        super.destroy()

        this.ring?.destroy?.()

        gsap.ticker.remove(this.renderBind);
        window.removeEventListener('resize', this.checkResizeBind);
    }
}
